module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido20.812f3d31.svg";